module.exports = __webpack_public_path__ + "static/booklet-01@2x-4ad4cfa2e577952be77b65ce7d6c05fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/workshop/booklet-01@2x.png
// module id = 2727
// module chunks = 159849449761359